import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import DetailSection from './Detail'
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Redirect } from 'react-router-dom';
import RelatedSneakerSection from '../PageProductDetails/RelatedSneakers/index'

import { ModalLineInfo, ModalLoginNew, ModalNotVerified, ModalSentVerifyEmailDone } from '../Modals';
import { getHistoryShipping } from '../../actions/postalCodeAction';
import { doFetchProductDetails } from '../../actions/productAction';

const loadingTextCSS = {
  textAlign: 'center',
  height: '100px',
  margin: '30px',
  display: 'flex',
  justifyContent: 'center',
  alignSelf: 'center',
};

class PageCheckout extends Component {
  constructor(props) {
    super(props);
    const { id, slug } = props.match.params;
    const { box_condition, size, size_id, x } = queryString.parse(props.location.search);
    if (props.dataCart.product.id === undefined && this.props.match.isExact)
      this._goBack();
    this.state = {
      _urlParams: {
        id,
        slug,
        box_condition,
        size,
        size_id,
        x
      },
      _product: props.dataCart.product,
      _user_sell: props.dataCart.user_sell,
      _notAllow: props.dataCart.product.id === undefined && !this.props.match.isExact,
      modalLineOpen: false,
      latestShipping: null,
      loadingpage: true,
      modalOpen: true,
      isOpenVerifiedModal: false,
      toggleSentVerifiedDone: false,
      isNotVerifiedUser: false
    }
    this._handleCancel = this._handleCancel.bind(this);
  }

  componentDidMount() {
    // Validating _urlParams here...
    this.props.getHistoryShipping();
  }

  _goBack() {
    this.props.history.goBack();
  }

  _handleCancel(e) {
    e.preventDefault();
    this._goBack();
  }

  _onToggle = () => {
    this.setState({ modalLineOpen: !this.state.modalLineOpen })
  }

  handleNewSize = (sell) => {
    this.setState({
      _user_sell: sell
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { shippingHistory, provinces } = this.props.dataPostalCode
    const prevShippingHistory = prevProps.dataPostalCode.shippingHistory

    if (shippingHistory.status_code === 200 && !shippingHistory.isFetch && prevShippingHistory.isFetch != shippingHistory.isFetch) {
      const latestShipping = shippingHistory.data[0]
      let checkingIdProvince = provinces.data.filter((a, index) => {
        return a.name === (shippingHistory.data.length > 0 ? latestShipping.province : '')
      })
      this.setState({
        loadingpage: false,
        latestShipping
      })
    }

    if (prevShippingHistory.isFetch != shippingHistory.isFetch && !shippingHistory.isFetch) {
      if (shippingHistory.status_code === 200) {
        const latestShipping = shippingHistory.data[0]
        let checkingIdProvince = provinces.data.filter((a, index) => {
          return a.name === (shippingHistory.data.length > 0 ? latestShipping.province : '')
        })
        this.setState({
          loadingpage: false,
          latestShipping
        })
      } else if (shippingHistory.error) {
        if (shippingHistory.error.status_code == 403) {
          this.setState({
            loadingpage: false,
            isOpenVerifiedModal: true,
            isNotVerifiedUser: true
          })
        }
      }
    }

    if (prevState.isOpenVerifiedModal !== this.state.isOpenVerifiedModal) {
      if (!this.state.isOpenVerifiedModal && (shippingHistory.error && shippingHistory.error.status_code == 403)) {
        setTimeout(() => {
          if (!this.state.toggleSentVerifiedDone) this._goBack();
        }, 500)
      }
    }

    if (prevState.toggleSentVerifiedDone !== this.state.toggleSentVerifiedDone) {
      if (!this.state.toggleSentVerifiedDone && (shippingHistory.error && shippingHistory.error.status_code == 403)) {
        this._goBack();
      }
    }
  }

  _renderModalLogin() {
    return (
      <ModalLoginNew
        isOpen={this.state.modalOpen}
        onClosed={() => this.setState({ isModalOpen: false })}
      />
    )
  }

  _onToggleNotVerifiedInfoModal = () => {
    this.setState({ isOpenVerifiedModal: !this.state.isOpenVerifiedModal })
  }

  _onToggleSentVerifiedDoneModal = () => {
    this.setState({ 
      toggleSentVerifiedDone: !this.state.toggleSentVerifiedDone 
    });
  }

  render() {
    const { dataAuth } = this.props;

    if (this.state._notAllow)
      return <Redirect to="/" />
    if (this.props.allow === false)
      return this._renderModalLogin()
    if (this.state.loadingpage)
      return <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><KickImage style={loadingTextCSS} src="/images/loader.gif" alt="Loading..." /></div>

    if (!this.state.loadingpage && this.state.isNotVerifiedUser) {
      return (
        <>
          <ModalNotVerified
            isOpen={this.state.isOpenVerifiedModal}
            onToggle={this._onToggleNotVerifiedInfoModal}
            onSuccess={this._onToggleSentVerifiedDoneModal}
            email={dataAuth.userdata.typed_email ? dataAuth.userdata.typed_email : dataAuth.userdata.email}
          /> 

          <ModalSentVerifyEmailDone
            isOpen={this.state.toggleSentVerifiedDone}
            onToggle={this._onToggleSentVerifiedDoneModal}
            email={dataAuth.userdata.typed_email ? dataAuth.userdata.typed_email : dataAuth.userdata.email}
          />
        </>
      )
    }

    return (
      <div>
        <ModalLineInfo isOpen={this.state.modalLineOpen} onToggle={this._onToggle} />
        <DetailSection
          dataAuth={this.props.dataAuth}
          installments={this.props.dataKredivo}
          product={this.state._product}
          sell={this.state._user_sell}
          onCancel={this._handleCancel}
          match={this.props.match}
          onModalLine={this._onToggle}
          funcGetHistoryShipping={this.props.getHistoryShipping}
          dataAvailableSize={this.props.dataProduct.availables}
          submitSize={this.handleNewSize}
          history={this.props.history}
          latestShipping={this.state.latestShipping}
        />
        {/* <RelatedSneakerSection /> */}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataCart: state.dataProduct.cart,
  dataKredivo: state.dataPayment.kredivoAvailableInstallment,
  dataAuth: state.dataAuth,
  dataProduct: state.dataProduct.productDetails,
  dataPostalCode: state.dataPostalCode,
})

const mapDispatchToProps = dispatch => ({
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  doFetchProductDetails: (productId) => dispatch(doFetchProductDetails(productId))
})

export default connect(mapStateToProps, mapDispatchToProps)(PageCheckout)
